module.exports = __webpack_public_path__ + "img/no_data.9819f71a.png";